import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { env } from './utils/getEnv';

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    fallbackLng: 'en',
    debug: env.NODE_ENV === 'development' || env.REACT_APP_ENV === 'staging'
    // backend: {
    //   // for all available options read the backend's repository readme file
    //   loadPath: '/locales/{{lng}}/{{ns}}.json'
    // }
  });

export default i18n;
